import React, { useEffect, useState } from "react";
import { Grid, TextField, Button } from "@mui/material";
import axios from "axios";
import baseUrl from "../../../config/baseUrl";

function Shareholders() {
  const auth = sessionStorage.getItem("user");

  const [formState, setFormState] = useState({
    shareholder1_name: "",
    shareholder1_dob: "",
    shareholder1_nationality: "",
    shareholder2_name: "",
    shareholder2_dob: "",
    shareholder2_nationality: "",
  });

  const ReadData = async () => {
    try {
      let values = {
        tab: 4,
      };
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: `Bearer ${auth}`,
        },
      };
      let result = await axios.post(
        `${baseUrl}/defaultBusinesSettingData`,
        values,
        config
      );
      setFormState(result.data.result);
    } catch (error) {
      console.log(error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      let values = {
        shareholder1_name: formState.shareholder1_name,
        shareholder1_dob: formState.shareholder1_dob,
        shareholder1_nationality: formState.shareholder1_nationality,
        shareholder2_name: formState.shareholder2_name,
        shareholder2_dob: formState.shareholder2_dob,
        shareholder2_nationality: formState.shareholder2_nationality,
      };

      const config = {
        headers: {
          "Content-type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${auth}`,
        },
      };

      let result = await axios.post(
        `${baseUrl}/save_shareholder_info`,
        values,
        config
      );
      if (result.status === 200) {
        alert(result.data.message);
      } else {
        alert(result.data.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    ReadData();
  }, []);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={4}>
        <TextField
          fullWidth
          label="Name Of The First Shareholder"
          name="shareholder1_name"
          value={formState.shareholder1_name}
          variant="outlined"
          onChange={handleChange}
          helperText="Mandatory"
            InputLabelProps={{
                shrink: true
            }}
            FormHelperTextProps={{ sx: { color: 'red' } }}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextField
          fullWidth
          label="Date Of Birth First Shareholder"
          type="date"
          name="shareholder1_dob"
          value={formState.shareholder1_dob}
          variant="outlined"
          onChange={handleChange}
          helperText="Mandatory"
            InputLabelProps={{
                shrink: true
            }}
            FormHelperTextProps={{ sx: { color: 'red' } }}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextField
          fullWidth
          label="Nationality of First Shareholder"
          name="shareholder1_nationality"
          value={formState.shareholder1_nationality}
          variant="outlined"
          onChange={handleChange}
          helperText="Mandatory"
            InputLabelProps={{
                shrink: true
            }}
            FormHelperTextProps={{ sx: { color: 'red' } }}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextField
          fullWidth
          label="Name Of The Second Shareholder"
          name="shareholder2_name"
          value={formState.shareholder2_name}
          variant="outlined"
          onChange={handleChange}
          helperText="Optional"
            InputLabelProps={{
                shrink: true
            }}
            FormHelperTextProps={{ sx: { color: 'orange' } }}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextField
          fullWidth
          label="Date Of Birth Of Second Shareholder"
          type="date"
          name="shareholder2_dob"
          value={formState.shareholder2_dob}
          variant="outlined"
          onChange={handleChange}
          helperText="Optional"
            InputLabelProps={{
                shrink: true
            }}
            FormHelperTextProps={{ sx: { color: 'orange' } }}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextField
          fullWidth
          label="Nationality Of Second Shareholder"
          name="shareholder2_nationality"
          value={formState.shareholder2_nationality}
          variant="outlined"
          onChange={handleChange}
          helperText="Optional"
            InputLabelProps={{
                shrink: true
            }}
            FormHelperTextProps={{ sx: { color: 'orange' } }}
        />
      </Grid>
      <Grid item xs={12} sm={12}>
        <Button
          onClick={handleSave}
          variant="contained"
          color="success"
          size="medium"
          sx={{
            float: "inline-end",
          }}
        >
          Save
        </Button>
      </Grid>
    </Grid>
  );
}

export default Shareholders;
